(function () {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canvas = document.getElementById('maintenance-overlay-bg');
  const veil = document.getElementById('maintenance-overlay-veil');

  if (!canvas || reduced) {
    if (canvas) canvas.remove();
    if (veil) veil.remove();
    return;
  }

  const script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/three@0.158.0/build/three.min.js';
  script.onload = boot;
  document.head.appendChild(script);

  function boot() {
    const scene = new THREE.Scene();
    scene.fog = new THREE.Fog(0xffffff, 4.5, 22);

    const isMobile = window.innerWidth <= 640;
    const isPortrait = window.innerHeight > window.innerWidth;
    const fov = isPortrait ? 72 : 55;
    const camY = isPortrait ? 1.7 : 1.35;
    const camZ = isPortrait ? 4.8 : 5.5;
    const lookY = isPortrait ? 0.5 : 0.6;

    const camera = new THREE.PerspectiveCamera(
      fov,
      window.innerWidth / window.innerHeight,
      0.1,
      100
    );
    camera.position.set(0, camY, camZ);
    camera.lookAt(0, lookY, 0);

    const renderer = new THREE.WebGLRenderer({ canvas, antialias: !isMobile, alpha: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, isMobile ? 1.5 : 1.75));
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setClearColor(0x000000, 0);

    const GRID_SIZE = 60;
    const GRID_DIV = isMobile ? 30 : 60;
    const CELL = GRID_SIZE / GRID_DIV;

    function makeGrid(color, opacity, yOffset) {
      const geo = new THREE.PlaneGeometry(GRID_SIZE, GRID_SIZE, GRID_DIV, GRID_DIV);
      const wire = new THREE.WireframeGeometry(geo);
      const mat = new THREE.LineBasicMaterial({ color, transparent: true, opacity });
      const grid = new THREE.LineSegments(wire, mat);
      grid.rotation.x = -Math.PI / 2;
      grid.position.y = yOffset;
      scene.add(grid);
      return grid;
    }

    const gridA = makeGrid(0x4a82c4, 0.28, -1.6);
    const gridB = makeGrid(0x060722, 0.05, -1.61);

    const target = { x: 0, y: 0 };
    const current = { x: 0, y: 0 };

    window.addEventListener(
      'mousemove',
      (e) => {
        target.x = (e.clientX / window.innerWidth - 0.5) * 0.8;
        target.y = (e.clientY / window.innerHeight - 0.5) * 0.4;
      },
      { passive: true }
    );

    window.addEventListener('resize', () => {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    });

    let running = true;
    document.addEventListener('visibilitychange', () => {
      running = document.visibilityState === 'visible';
      if (running) tick();
    });

    const clock = new THREE.Clock();

    function tick() {
      if (!running) return;
      const t = clock.getElapsedTime();
      const scroll = (t * 0.45) % CELL;
      gridA.position.z = scroll;
      gridB.position.z = scroll;
      current.x += (target.x - current.x) * 0.04;
      current.y += (target.y - current.y) * 0.04;
      camera.position.x = current.x * 0.6;
      camera.position.y = camY - current.y * 0.25;
      camera.lookAt(current.x * 0.3, lookY, 0);
      renderer.render(scene, camera);
      requestAnimationFrame(tick);
    }

    tick();
  }
})();
